import React, { Component } from 'react';
import { Link } from 'react-router-dom';

const liff = window.liff;

export class StoresettingTempcloseAddConfirm extends Component {
    static displayName = StoresettingTempcloseAddConfirm.name;

    constructor(props) {
        super(props);

        this.state = {
            ModelCss01: "popuphide",
            ModelCssButton: "btn btn-lg mb-0 btn-register-cancelled",
            roomid: this.props.location.state.roomid,
            susdate: this.props.location.state.susdate,
            sustimestart: this.props.location.state.sustimestart,
            sustimeend: this.props.location.state.sustimeend,
            period: this.props.location.state.period,
            storeName: "",
            roomName: "",
            susDateTxt: "",
            susDateHrStartTxt: "",
            susDateHrEndTxt: ""
        };

        this.onSubmitForm = this.onSubmitForm.bind(this);
    }

    async onSubmitForm() {
        //Godd to go

        // POST request using fetch inside useEffect React hook                    
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(
                {
                    UserId: this.state.userLineID,
                    RoomID: this.state.roomid,
                    SuspendedDate: this.state.susdate,
                    SuspendedTimeStart: this.state.sustimestart,
                    SuspendedTimeEnd: this.state.sustimeend,
                    SuspendedTimePreriod: this.state.period
                }
            )
        };

        const response = await fetch('/api/partnertempcloseroomadd', requestOptions);
        const data = await response.json();

        if (data.responsecode === "OK") {
            //Success add Temp close
            this.props.history.push('/StoresettingTempclose')
        }
        else if (data.responsecode === "E02") {
            //Error E02-Have booking on that preriod
            this.props.history.push({
                pathname: "/StoresettingTempcloseAddErr02",
                state: {
                    ErrorTxt: data.responsemessage,
                    storeName: data.storeName,
                    roomName: data.roomName,
                    susDateTxt: data.susDateTxt,
                    susDateHrStartTxt: data.susDateHrStartTxt,
                    susDateHrEndTxt: data.susDateHrEndTxt,
                    roomid: data.roomID
                }
            });
        }
        else {
            this.props.history.push({
                pathname: "/Mistake",
                state: {
                    ErrorTxt: data.responsemessage
                }
            });
        }
    }

    componentDidMount() {
        this.populateProfile();
    }

    closeLIFF() {
        liff.closeWindow();
    }

    async populateProfile() {
        if (!liff.isInClient()) {
            this.props.history.push('/NotInLine');

            //let LineuserId = "x1";
            //let LineuserPicture = "";              
        } else {
            liff.init({
                liffId: '1661485377-z2p58Y1Z'
            }).then(async () => {
                let LineuserId = "";
                let LineuserPicture = "";

                await liff.getProfile()
                    .then(profile => {
                        LineuserId = profile.userId;
                        LineuserPicture = profile.pictureUrl;
                    })
                    .catch((err) => {
                        LineuserId = "Err";
                    });

                if (LineuserId === "Err") {
                    this.props.history.push('/MistakeLine')
                }
                else {
                    //action - start

                    //check Partners exists or not - start
                    const requestOptions = {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(
                            {
                                UserId: LineuserId
                            }
                        )
                    };

                    await fetch('/api/partnercheck', requestOptions)
                        .then(response => response.json())
                        .then(json => {
                            if (json.responsecode === "Approve") {
                                //Partners exists and already approve-> Show This page
                                this.setState({
                                    userLineID: LineuserId
                                });

                            }
                            else {
                                //Partners not exists or not approve -> Show Home page
                                this.props.history.push('/')
                            }
                        });
                    //check Partners exists or not - end

                    //Get Detail to display - start
                    // POST request using fetch inside useEffect React hook                    
                    const requestOptions2 = {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(
                            {
                                UserId: this.state.userLineID,
                                RoomID: this.state.roomid,
                                SuspendedDate: this.state.susdate,
                                SuspendedTimeStart: this.state.sustimestart,
                                SuspendedTimeEnd: this.state.sustimeend,
                                SuspendedTimePreriod: this.state.period
                            }
                        )
                    };

                    const response2 = await fetch('/api/PartnerTempCloseRoomAddB4Confirm', requestOptions2);
                    const data2 = await response2.json();

                    if (data2.responsecode === "OK") {
                        //Set state to show                        
                        this.setState({
                            storeName: data2.storeName,
                            roomName: data2.roomName,
                            susDateTxt: data2.susDateTxt,
                            susDateHrStartTxt: data2.susDateHrStartTxt,
                            susDateHrEndTxt: data2.susDateHrEndTxt
                        });
                    }
                    //Get Detail to display - end


                    //action - end
                }
            });
        }
    }

    render() {
        return (
            <div className="form-signin shadow bg-home position-relative">
                <div className="head-nav p-0">
                    <img src={require("./media/stb_partner.png")} alt="SBUX Partner Portal" className="img-fluid mt-0 mb-0" />
                </div>
                {
                    (this.state.userLineID && this.state.userLineID !== '')
                        ?
                        <>
                            <div className="form-enter pt-0 mt-4">
                                <h2 className="h4 text-center pt-0 mb-0 fontsodo-bold">Temporary Store Closure</h2>
                                <div className="row p-3 pb-0">
                                    <div className="col-2"><p className="fontsodo-semibold mb-0">Store</p></div>
                                    <div className="col-10"><p className="fontsodo-semibold text-green mb-0">{this.state.storeName}</p></div>
                                </div>
                                <div className="row p-3 pb-0">
                                    <div className="col-2"><p className="fontsodo-semibold mb-0">Room</p></div>
                                    <div className="col-10"><p className="fontsodo-semibold text-green mb-0">{this.state.roomName}</p></div>
                                </div>
                                <div className="row p-3 pb-0">
                                    <div className="col-2"><p className="fontsodo-semibold mb-0">Date</p></div>
                                    <div className="col-10"><p className="fontsodo-semibold mb-0"><img src={require("./media/Icon-feather-calendar.png")} alt="Date" className="ms-0 me-2" /> {this.state.susDateTxt}</p></div>
                                </div>
                                <div className="row p-3 pb-0">
                                    <div className="col-2"><p className="fontsodo-semibold mb-0">Time</p></div>
                                    <div className="col-10"><p className="fontsodo-semibold mb-0"><img src={require("./media/Icon-feather-clock.png")} alt="Time" className="ms-0 me-2" /> {this.state.susDateHrStartTxt} - {this.state.susDateHrEndTxt}</p></div>
                                </div>
                            </div>
                            <div className="box-footer-button position-relative">
                                <div className="row text-center mt-3 mb-0 justify-content-center">
                                    <div className="col-6">
                                        <div className="d-grid">
                                            <Link to="/StoresettingTempclose" className="btn btn-lg mb-0 btn-register-3">Back</Link>
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="d-grid">
                                            <input type="button" className="btn btn-lg mb-0 btn-register-2" onClick={this.onSubmitForm} defaultValue="Confirm" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                        :
                        <>
                            <div className="form-enter mt-1 pb-0">
                                <form>
                                    <div className="text-center" style={{ height: '160px' }} />
                                    <div className="text-center mt-5 pt-5 mb-5 pb-5">
                                        <h3 className="text-white">LOADING ...</h3>
                                        <img src={require("./media/loading-gif.gif")} alt="Loading..." width={80} className="img-fluid" />
                                    </div>
                                    <div style={{ height: '100px' }} />
                                </form>
                            </div>
                        </>
                }
            </div>
        );
    }
}